import logging from '../logging';

const log = logging('control-flow');

/**
 * Executes a callback on every frame while the loop is running. This is
 * different from the conditional animation loop used by the floor planner
 * or some of the other implementations because it does not track when updates
 * are needed: they're assumed to happen all the time while the 
 */
export class AnimationLoop {
    callback: () => unknown;
    running: boolean = false;

    constructor(callback: () => unknown) {
        this.callback = callback;
    }

    animate = () => {
        if(this.running) {
            requestAnimationFrame(this.animate);
            try {
                this.callback();
            } catch(error) {
                log.error(
                    'Stopping this AnimationLoop due to unhandled exception in the callback function', error);
                this.running = false;
            }
        }
    }

    start() {
        this.running = true;
        this.animate();
    }

    stop() {
        this.running = false;
    }
}
export default AnimationLoop;
